import { render, staticRenderFns } from "./goodsPurchase.vue?vue&type=template&id=0db00159&scoped=true"
import script from "./goodsPurchase.vue?vue&type=script&lang=js"
export * from "./goodsPurchase.vue?vue&type=script&lang=js"
import style0 from "./goodsPurchase.vue?vue&type=style&index=0&id=0db00159&prod&scoped=true&lang=css"
import style1 from "./goodsPurchase.vue?vue&type=style&index=1&id=0db00159&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db00159",
  null
  
)

export default component.exports